import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MEDIA } from "@/lib/data";

const THUMBS = [
  { src: MEDIA.showroom_wd40, alt: "Lubrificantes WD-40", tag: "Lubrificantes" },
  { src: MEDIA.showroom_ral, alt: "Sprays de tinta — toda a gama de cores", tag: "Sprays de Tinta" },
  { src: MEDIA.showroom_screwdrivers, alt: "Expositor de chaves de fendas", tag: "Ferramentas" },
  { src: MEDIA.showroom_sockets, alt: "Conjuntos de chaves e roquetes cromados", tag: "Roquetes" },
];

export default function HomeShowroom() {
  return (
    <section className="bg-[#0a0a0a] text-white py-24 md:py-32 relative overflow-hidden" data-testid="home-showroom">
      <div className="grain absolute inset-0" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 md:mb-16 gap-6">
          <div>
            <div className="overline mb-4">Showroom & Armazém · Maia</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-3xl">
              Stock real.<br />
              <span className="text-[#1FA8E0]">+10.000 referências</span> prontas a entregar.
            </h2>
          </div>
          <Link to="/contactos" data-testid="showroom-cta" className="btn-cet btn-primary self-start shrink-0">
            Visitar Showroom <ArrowUpRight size={18} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-3 md:gap-4">
          {/* Large hero image */}
          <div
            data-testid="showroom-hero-image"
            className="col-span-2 row-span-2 relative overflow-hidden border border-white/10 group"
          >
            <img
              src={MEDIA.showroom_overview}
              alt="Showroom CETIBER — vista geral da loja"
              loading="lazy"
              className="w-full h-full object-cover aspect-square md:aspect-auto transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <div className="font-mono-cet text-[11px] tracking-widest text-[#1FA8E0]">LOC · MAIA</div>
              <div className="font-display font-bold text-white uppercase text-2xl md:text-3xl mt-1">
                IRWIN · IRIMO · Mundial · Stanley · AEG · Bianditz
              </div>
            </div>
          </div>

          {/* 4 thumbnails */}
          {THUMBS.map((t, i) => (
            <div
              key={i}
              data-testid={`showroom-thumb-${i}`}
              className="relative overflow-hidden border border-white/10 group aspect-square md:aspect-auto"
            >
              <img
                src={t.src}
                alt={t.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.08]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute top-3 left-3 font-mono-cet text-[10px] tracking-widest bg-[#1FA8E0] text-[#0a1e2e] px-2 py-1">
                {t.tag}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 pt-10 border-t border-white/10">
          {[
            { k: "500 m²", l: "Área de Showroom" },
            { k: "+50", l: "Marcas em Stock" },
            { k: "24h", l: "Entrega na Região" },
            { k: "+10.000", l: "Referências" },
          ].map((s) => (
            <div key={s.l} className="flex flex-col gap-1">
              <span className="font-display font-black text-3xl md:text-4xl text-[#1FA8E0]">{s.k}</span>
              <span className="font-mono-cet text-[11px] uppercase tracking-[0.2em] text-white/60">{s.l}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
